import { useMediaQuery } from 'react-responsive';
import { ITableContainerProps } from '../../../types/Interfaces';
import { useTranslation } from 'react-i18next';
import { IDashboardUserOrder } from '../interfaces';
import moment from 'moment';
import ExportExcel from '../../../components/buttons/ExportExcel/ExportExcel';

const UsersOrdersTableContainer = ({ tableHeaders, data, noDataMessage, lessColumns }: ITableContainerProps<IDashboardUserOrder[]>) => {
  const { t } = useTranslation();
  const isDesktop = useMediaQuery({ query: '(min-width: 1024px)' });

  return (
    <div className={`table_container ${lessColumns && isDesktop && 'lessColumns'} hasPagination`}>
      <div className="table_header">
        {tableHeaders?.map(
          (header, index) =>
            header && (
              <span className={`head ${header.customClass}`} key={index}>
                {header.label}
              </span>
            )
        )}
      </div>
      <div className={`table_data ${(!data || data?.length === 0) && 'no_data'}`}>
        {data?.length > 0 ? (
          <>
            {data?.map((item, index) => (
              <div className={`item has_logo orders`} key={index}>
                <div className="column actions actions_col                                      ">{item?.order_id || '-'}</div>
                <div className="column">{moment(item?.order_date).format('DD/MM/YYYY') || '-'}</div>
                <div className="column" style={{whiteSpace: "pre-line"}}>
                  <div>{item?.model_name || '-'}</div>
                  <div>{item?.variant_name || '-'}</div>
                </div>
                <div className="column" style={{whiteSpace: "pre-line"}}>
                  <div>{item?.interior_color_name || '-'}</div> <div>{item?.exterior_color_name || '-'}</div>
                </div>
                <div className="column">{item?.showroom_name || '-'}</div>
                <div className="column">{item?.city_name || '-'}</div>
                <div className="column">{item?.paid_amount || '-'} {t('sar')}</div>
                <div className="column">{item?.total || '-'} {t('sar')}</div>
              </div>
            ))}
          </>
        ) : (
          <h6>{noDataMessage}</h6>
        )}
      </div>
    </div>
  );
};

export default UsersOrdersTableContainer;
